<p-toast
  position="bottom-center"
  [baseZIndex]="10000"
  [preventOpenDuplicates]="true"
  appendTo="body"
  styleClass="wtg-toast-container"
>
  <ng-template let-message pTemplate="message">
    <div
      class="wtg-toast"
      [ngClass]="'wtg-toast--' + (message.severity || 'info')"
      [style.--wtg-toast-life.ms]="getMessageLife(message)"
    >
      <div class="wtg-toast__progress"></div>
      <div class="p-toast-message-content wtg-toast__content">
        <i class="p-toast-message-icon wtg-toast__icon" [ngClass]="getSeverityIcon(message.severity)"></i>
        <div class="p-toast-message-text wtg-toast__text">
          <div class="p-toast-summary">{{ message.summary }}</div>
          <div class="p-toast-detail">{{ message.detail }}</div>
          <div *ngIf="message.severity === 'error'" class="mt-2">
          <button pButton type="button" icon="fas fa-bug" class="p-button-sm p-button-text"
                  (click)="openBugReport(message)">
            {{ 'shared.modal.modal_service.report_bug.trigger' | translate }}
          </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
